<div class="container-fluid p-5 pt-3" style="min-height: calc(100vh - 57px) !important">
    <div class="row">
        <div class="col-12 ps-5">
            <div aria-label="breadcrumb" class="text-right float-right">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a class="fzas-breadcrumb-grey" routerLink="/private/lista-procesos">HOME</a></li>
                    <li class="breadcrumb-item"><a class="fzas-breadcrumb-blue">Centralización Remuneraciones</a></li>
                </ol>
            </div>
        </div>
        <div class="col-12 ps-5">
            <p class="fzas-titulo-componente">Lista de Procesos</p>
        </div>
        <div class="col-12">
            <div class="container card-container">
                <div class="row">
                    <div class="col px-4 pt-3">
                        <div class="card fzas-card-filtros">
                            <div class="card-body p-4">
                                <form [formGroup]="filtrosForm" class="row">
                                    <div class="col-12">
                                        <p class="fzas-title-filtros">Buscar Proceso</p>
                                    </div>
                                    <div class="col-12 col-md-6 col-xl-3">
                                        <label for="procesoNombre" class="form-label fzas-text-input">Nombre Proceso</label>
                                        <input type="text" formControlName="procesoNombre" name="procesoNombre" placeholder="Escribe el nombre del proceso" class="form-control" (input)="validarAlfanumerico($event)"/>
                                    </div>
                                    <div class="col-12 col-md-6 col-xl-3">
                                        <label for="procesoPeriodo" class="form-label fzas-text-input">Periodo</label>
                                        <div class="row">
                                            <div class="col-12">
                                                <p-calendar
                                                  class="calendar-periodo"
                                                  formControlName="procesoPeriodo"
                                                  name="procesoPeriodo"
                                                  placeholder="Mes/Año"
                                                  (onSelect)="onChangePeriodo($event)"
                                                  view="month"
                                                  dateFormat="M/yy"
                                                  [readonlyInput]="true"
                                                  [yearNavigator]="true"
                                                  [monthNavigator]="true"
                                                  [yearRange]="'2000:2030'">
                                                </p-calendar>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6 col-xl-3">
                                        <label for="procesoEstado" class="form-label fzas-text-input">Estado</label>
                                        <select formControlName="procesoEstado" name="procesoEstado" class="form-control fzas-custom-select">
                                            <option value="">Seleccione Estado</option>
                                            <option *ngFor="let estado of procesoEstados" [value]="estado.value">{{ estado.name }}</option>
                                        </select>
                                    </div>
                                    <div class="col-12 col-md-6 col-xl-3">
                                        <label for="procesoTipo" class="form-label fzas-text-input">Tipo</label>
                                        <select formControlName="procesoTipo" name="procesoTipo" class="form-control fzas-custom-select">
                                            <option value="">Seleccione Tipo</option>
                                            <option *ngFor="let tipo of procesoTipos" [value]="tipo.value">{{ tipo.name }}</option>
                                        </select>
                                    </div>
                                    <div class="col-12 mt-4 d-flex justify-content-end gap-3">
                                        <button type="button" class="btn btn-cancelar-accion" (click)="limpiarFiltros()">Limpiar Filtros</button>
                                        <button type="button" class="btn btn-aplicar-accion" (click)="obtenerProcesosFiltrados()">Aplicar Filtros</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="container">
                <div class="row">
                    <div class="col-12 px-4 pt-4 d-flex justify-content-end gap-3" >
                        <div >
                        <button type="button" class="btn btn-aplicar-accion" (click)="costCenter()">Mantener Centros</button></div>
                        <div ngbDropdown >
                            <button type="button" class="btn btn-aplicar-accion btn-nuevo-proceso" id="dropdownBasic1" ngbDropdownToggle>
                                <span class="pe-2">Crear Nuevo Proceso</span>
                                <img src="./assets/icon/dropdown-flecha.svg" alt="">
                            </button>
                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="p-0">
                                <button class="w-100 py-2 d-flex align-items-center"  (click)="createProcess('Normal')" ngbDropdownItem>
                                    <img src="./assets/icon/newNormal.svg" alt="" width="14px" class="me-2">
                                    <span class="fzas-text-dropdownmenu">
                                        Normal
                                    </span>
                                </button>
                                <button class="w-100 py-2 d-flex align-items-center" (click)="createProcess('Especial')" ngbDropdownItem>
                                    <img src="./assets/icon/newEspecial.svg" alt="" width="14px" class="me-2">
                                    <span class="fzas-text-dropdownmenu">
                                        Especial
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="container">
                <div class="row">
                    <div class="col-12 px-4 pt-4">
                        <table mat-table [dataSource]="dataSource" multiTemplateDataRows style="width: 100%">
    
                            <ng-container matColumnDef="procesoTipo">
                                <th mat-header-cell *matHeaderCellDef  style="text-align: center !important; min-width: 100px !important;">Tipo</th>
                                <td mat-cell *matCellDef="let element" style="text-align: center !important; max-width: 127px !important;">{{ element.procTipo }}</td>
                            </ng-container>
    
                            <ng-container matColumnDef="procesoNombre">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center !important;">Nombre</th>
                                <td mat-cell *matCellDef="let element" style="text-align: center !important; max-width: 267px !important;">{{ element.procNombre }}</td>
                            </ng-container>
    
                            <ng-container matColumnDef="procesoPeriodo">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center !important;">Periodo</th>
                                <td mat-cell *matCellDef="let element" style="text-align: center !important; max-width: 132px !important;">{{ element.procPeriodo }}</td>
                            </ng-container>
    
                            <ng-container matColumnDef="procesoFechaCreacion">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center !important; min-width: 160px !important;">Fecha Creación
                                    <img src="./assets/icon/flecha-sort.svg" alt="" width="14px" class="mb-1">
                                </th>
                                <td mat-cell *matCellDef="let element" style="text-align: center !important; max-width: 200px !important;">{{ element.procCreateAt | date: 'dd/MM/yyyy HH:mm' }}</td>
                            </ng-container>
    
                            <ng-container matColumnDef="procesoEstado">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center !important;">Estado</th>
                                <td mat-cell *matCellDef="let element" class="text-center">
                                    <ng-container *ngIf="element.estProcesoId == 2">
                                        <span class="fzas-badge-cerrado">Cerrado</span>
                                    </ng-container>
                                    <ng-container *ngIf="element.estProcesoId == 1">
                                        <span class="fzas-badge-abierto">Abierto</span>
                                    </ng-container>
                                </td>
                            </ng-container>

                            <!-- PROPUESTA DE ELLOS -->
                            <ng-container matColumnDef="procesoCentros">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center !important;">Proceso</th>
                                <td mat-cell *matCellDef="let element" style="max-width: 180px !important;">
                                    <div class="col-12 py-1 d-flex flex-wrap justify-content-center align-items-center gap-1">
                                        <ng-container *ngFor="let centro of element.centroProceso">
                                            <div 
                                                class="fzas-centro-avatar-incompleto"
                                                matTooltipClass="fzas-info-tooltip"
                                                [matTooltip]="centro.centProcNombre" matTooltipPosition="above"
                                                *ngIf="centro.estCentroId == 1 || centro.estCentroId == 4">
                                                {{ centro.centProcIniciales || '--' }}
                                            </div>
                                            <div 
                                                class="fzas-centro-avatar-procesado"
                                                matTooltipClass="fzas-info-tooltip"
                                                [matTooltip]="centro.centProcNombre" matTooltipPosition="above"
                                                *ngIf="centro.estCentroId == 2">
                                                {{ centro.centProcIniciales || '--' }}
                                            </div>
                                            <div 
                                                class="fzas-centro-avatar-cerrado"
                                                matTooltipClass="fzas-info-tooltip"
                                                [matTooltip]="centro.centProcNombre" matTooltipPosition="above"
                                                *ngIf="centro.estCentroId == 3">
                                                {{ centro.centProcIniciales || '--' }}
                                            </div>
                                        </ng-container>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- PROPUESTA NUESTRA -->
                            <!-- <ng-container matColumnDef="procesoCentros">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center !important;">Ver Procesos</th>
                                <td mat-cell *matCellDef="let element" class="text-center">
                                    <a role="button" (click)="expandCollapse(element)">
                                        <img *ngIf="!element.expanded" src="./assets/icon/ver-mas-grid.svg" />
                                        <img *ngIf="element.expanded" src="./assets/icon/ver-menos-grid.svg" />
                                    </a>
                                </td>
                            </ng-container> -->

                            <ng-container matColumnDef="procesoOpciones">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center !important;">Opciones</th>
                                <td mat-cell *matCellDef="let element" class="text-center">
                                    <div ngbDropdown container="body">
                                         <!-- <button class="w-100 py-2 d-flex align-items-center"
                                            (click)="abrirModalEliminarProceso(element.procId, element.procNombre)" ngbDropdownItem>
                                            <img src="./assets/icon/anular.svg" alt="" width="14px" class="ms-1 me-2">
                                            <span class="fzas-text-dropdownmenu">
                                                Eliminar
                                            </span>
                                        </button>  -->
                                        <button type="button" class="btn border-0 btn-opciones" id="dropdownBasic1" ngbDropdownToggle>
                                            <img src="./assets/icon/opciones-grid.svg">
                                        </button>
                                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="p-0">
                                            <ng-container>
                                                <button class="w-100 py-2 d-flex align-items-center" (click)="visualizarProceso(element.procId, element.procTipo)" ngbDropdownItem>
                                                    <img src="./assets/icon/visualizar.svg" alt="" width="18px" class="me-2">
                                                    <span class="fzas-text-dropdownmenu">
                                                        Visualizar
                                                    </span>
                                                </button>
                                                <ng-container *ngIf="element.estProcesoId == 2 && (usuarioActual.us_rol == 1 || usuarioActual.us_rol == 2)">
                                                    <button class="w-100 py-2 d-flex align-items-center" (click)="abrirModalReabrirProceso(element.procId, element.procTipo, element.procNombre)" ngbDropdownItem>
                                                        <img src="./assets/icon/reabrir.svg" alt="" width="18px" class="me-2">
                                                        <span class="fzas-text-dropdownmenu">
                                                            Reabrir
                                                        </span>
                                                    </button>
                                                </ng-container>
                                            </ng-container>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="expandedDetail">
                                <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length"  class="">
                                    <div class="example-element-detail" [@detailExpand]="element.expanded === true ? 'expanded' : 'collapsed'">
                                        <div class="row py-3">
                                            <div class="col-12 d-flex justify-content-center align-items-center gap-2">
                                                <ng-container *ngFor="let centro of element.procesoCentros">
                                                    <div class="fzas-centro-avatar-incompleto" *ngIf="centro.estCentroId == 1 || centro.estCentroId == 4">{{ centro.nombreAvatar }}</div>
                                                    <div class="fzas-centro-avatar-procesado" *ngIf="centro.estCentroId == 2">{{ centro.nombreAvatar }}</div>
                                                    <div class="fzas-centro-avatar-cerrado" *ngIf="centro.estCentroId == 3">{{ centro.nombreAvatar }}</div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>
    
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns" class="example-element-row" [class.example-expanded-row]="row.expanded"></tr>
                            <!-- <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr> -->
                            <tr class="mat-row" *matNoDataRow>
                            
                                <td class="mat-cell py-3 text-center" [attr.colspan]="displayedColumns.length">No hay procesos registrados.</td>
                            </tr> 
                        </table>
                        
                        <mat-paginator [length]="totalRows" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"></mat-paginator>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>